<template>
	<form class="mc-form" :class="[
    labelPosition ? 'mc-form--label-' + labelPosition : '',
    { 'mc-form--inline': inline }
  ]">
		<slot></slot>
	</form>
</template>
<script>
    import {objectAssign} from '../utils/util';

    export default {
        name: 'mcForm',

        componentName: 'ElForm',

        provide() {
            return {
                mcForm: this
            };
        },

        props: {
            model: Object,
            rules: Object,
            labelPosition: String,
            labelWidth: String,
            labelSuffix: {
                type: String,
                default: ''
            },
            inline: Boolean,
            inlineMessage: Boolean,
            statusIcon: Boolean,
            showMessage: {
                type: Boolean,
                default: true
            },
            size: String,
            disabled: Boolean,
            validateOnRuleChange: {
                type: Boolean,
                default: true
            }
        },
        watch: {
            rules() {
                if (this.validateOnRuleChange) {
                    this.validate(() => {
                    });
                }
            }
        },
        data() {
            return {
                fields: []
            };
        },
        created() {
            this.$on('el.form.addField', (field) => {
                if (field) {
                    this.fields.push(field);
                }
            });
            /* istanbul ignore next */
            this.$on('el.form.removeField', (field) => {
                if (field.prop) {
                    this.fields.splice(this.fields.indexOf(field), 1);
                }
            });
        },
        methods: {
            resetFields() {
                if (!this.model) {
                    process.env.NODE_ENV !== 'production' &&
                    console.warn('[Element Warn][Form]model is required for resetFields to work.');
                    return;
                }
                this.fields.forEach(field => {
                    field.resetField();
                });
            },
            clearValidate() {
                this.fields.forEach(field => {
                    field.clearValidate();
                });
            },
            validate(callback, options = {}) {
	            const {hideVisual = false} = options;
                if (!this.model) {
                    console.warn('[Element Warn][Form]model is required for validate to work!');
                    return;
                }

                let promise;
                // if no callback, return promise
                if (typeof callback !== 'function' && window.Promise) {
                    promise = new window.Promise((resolve, reject) => {
                        callback = function (valid) {
                            valid ? resolve(valid) : reject(valid);
                        };
                    });
                }

                let valid = true;
                let count = 0;
                // 如果需要验证的fields为空，调用验证时立刻返回callback
                if (this.fields.length === 0 && callback) {
                    callback(true);
                }
                let invalidFields = {};
                this.fields.forEach(field => {
                    field.validate('', (message, field) => {
                        if (message) {
                            valid = false;
                        }
                        invalidFields = objectAssign({}, invalidFields, field);
                        if (typeof callback === 'function' && ++count === this.fields.length) {
                            callback(valid, invalidFields);
                        }
                    }, {hideVisual});
                });

                if (promise) {
                    return promise;
                }
            },
            validateField(prop, cb) {
                let field = this.fields.filter(field => field.prop === prop)[0];
                if (!field) {
                    throw new Error('must call validateField with valid prop string!');
                }

                field.validate('', cb);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/form.vue